import React from 'react';
import ServiceCard from './ServiceCard';
import { GoMoveToTop } from "react-icons/go";
const LaserEtching = () => {
  return (
    <>
<ServiceCard
id="#"
  title="Laser Etching"
  description="Laser etching is a modern technique that uses a concentrated beam of light to permanently mark or engrave surfaces. It works on materials like wood, metal, glass, acrylic, leather, and coated plastics, creating durable, precise designs without ink or thread."
  fullDescription={` Laser etching has its origins in the development of laser technology in the 1960s, initially for industrial and scientific applications. Over time, it evolved into a precise method for marking, engraving, and cutting materials with exceptional accuracy.

Today, laser etching physically alters the surface of an item, making designs resistant to wear, moisture, and fading. It's perfect for detailed logos, serial numbers, barcodes, personalized text, promotional items, plaques, awards, and industrial tags.

At our facility, we use high-speed CO2 and fiber laser machines capable of both raster engraving (photos and artwork) and vector cutting (shapes and outlines). This allows us to mark or cut custom designs with extreme precision across a wide range of materials and product shapes.

Laser etching is eco-friendly, using no inks or chemicals, producing minimal waste, and works well for small batches or one-off projects. Our team optimizes your artwork for clean and precise results, giving you a modern, durable, and elegant customization option.`}
  images={[
    
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925327/my_uploads/tpsj3abofnlxv9maxyfu.jpg",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925329/my_uploads/br3jktg9fcdmer04o3wx.jpg",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925330/my_uploads/uxon4fhvlvsxdnqssp8p.jpg",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925331/my_uploads/cdn9lm51onimuimtpgjc.png",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925331/my_uploads/bs2xamdgjcujnfv5oj0l.png",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925332/my_uploads/d1olplo9yyknrdmapxh2.png",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925333/my_uploads/jisecf9je8j7ej0hghlk.png"
  ]}
/>

                           <div>
                             <a
                               href="#"
                               style={{ textDecoration: "none", color: "black" }}
                             >
                               <p style={{ fontSize: "30px", fontWeight: "bold" }}>
                                 <GoMoveToTop />
                               </p>
                               <p style={{ marginTop: -25 }}>Top</p>
                             </a>
                           </div>
                           </>
  );
};

export default LaserEtching;
